import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Grid, Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { toast } from 'react-toastify'
import { TitleOnBoarding } from '../../../components/TitleOnBoarding'
import { InputCheckbox } from '../../../components/CustomInputs/InputCheckbox'
import { GreenButton } from '../../../components/Buttons/GreenButton'
import { useRest } from '../../../components/Context'
import { AccountType } from '../../../constants/accountType'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '0 auto',
    maxWidth: 1184,
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 'bold',
  },
  container: {
    width: '632px',
    marginTop: '81px',
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'unset',
  },
  link: {
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    lineHeight: '1.43',
    color: theme.palette.info.light,
    padding: 0,
    paddingLeft: 5,
    '&:hover': {
      background: 'transparent',
    },
  },
}))

interface ITermsAndConditions {
  title: string
}

interface IFormInputs {
  checkboxTermsAndConditions: boolean
}

export const TermsAndConditions: FC<ITermsAndConditions> = ({ title }) => {
  const classes = useStyles()
  const [activeStep] = useState(8)
  const [formDisabled, seFormDisabled] = useState<boolean>(true)
  const history = useHistory()
  const location = useLocation()
  const { rxios } = useRest()
  const { uniqKey } = useParams() as { [key: string]: string }
  const formMethods = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      checkboxTermsAndConditions: false,
    },
  })
  const { handleSubmit, watch } = formMethods

  useEffect(() => {
    const subscription = watch((value) => seFormDisabled(!value.checkboxTermsAndConditions))
    return () => subscription.unsubscribe()
  }, [watch])

  /**
   * Post request
   * user OR company/onboarding/terms-and-conditions/:hash
   */
  const onSubmit = useCallback(() => {
    rxios
      .post('user/onboarding/sum-sub/account-Type', {
        hash: uniqKey,
      })
      .subscribe(
        // eslint-disable-next-line
        (next: any) => {
          const url = next.accountType === AccountType.COMPANY ? AccountType.COMPANY : 'user'
          rxios
            .post(`${url}/onboarding/terms-and-conditions`, {
              hash: uniqKey,
            })
            .subscribe(
              () => {
                history.push({
                  ...location,
                  state: {
                    activeStep,
                  },
                })
              },
              (error) => {
                toast.error(error.response.data.message)
              },
            )
        },
        (error) => {
          toast.error(error.response.data.message)
        },
      )
  }, [rxios, uniqKey, history, location, activeStep])

  const renderTxt = () => {
    const handleClick = () => {
      window.open('/files/MTA.pdf')
    }

    return (
      <span className={classes.text}>
        I accept{' '}
        <Button onClick={handleClick} className={classes.link}>
          {' '}
          the terms and conditions
        </Button>
      </span>
    )
  }

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid className={classes.root} container direction="column" alignItems="center">
          <TitleOnBoarding title={title} leftArrow activeStep={activeStep} />
          <Grid item container className={classes.container} direction="column" alignItems={'center'}>
            <Grid item>
              <InputCheckbox name={'checkboxTermsAndConditions'} render={renderTxt()} />
            </Grid>
            <GreenButton disabled={formDisabled} text="NEXT" type="submit" width={321} mt={72} />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}
